module.exports = __webpack_public_path__ + "static/img/plan-task_05.8ce4ceab.png";